import React from "react";
import { Link, LinkProps, useSearchParams } from "react-router-dom";

/**
 * Custom Link component that preserves URL parameters (id, type, presentation)
 * when navigating to other routes. This ensures client state is maintained.
 */
export const LinkWithParams = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to, ...props }, ref) => {
    const [searchParams] = useSearchParams();

    // Extract current params we want to preserve
    const id = searchParams.get("id");
    const type = searchParams.get("type");
    const presentation = searchParams.get("presentation");

    // Build params to preserve
    const params = new URLSearchParams();
    if (id) params.set("id", id);
    if (type) params.set("type", type);
    if (presentation) params.set("presentation", presentation);

    // Construct the new URL with params
    const toWithParams = typeof to === "string" && params.toString()
      ? `${to}?${params}`
      : to;

    return <Link ref={ref} to={toWithParams} {...props} />;
  }
);

LinkWithParams.displayName = "LinkWithParams";
